const ALGO = ({ ...props }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        d="M10.2083 20C15.7311 20 20.2083 15.5228 20.2083 10C20.2083 4.47715 15.7311 0 10.2083 0C4.6854 0 0.208252 4.47715 0.208252 10C0.208252 15.5228 4.6854 20 10.2083 20Z"
        fill="black"
      />
      <path
        d="M10.2083 19.375C15.3859 19.375 19.5833 15.1777 19.5833 10C19.5833 4.82233 15.3859 0.625 10.2083 0.625C5.03058 0.625 0.833252 4.82233 0.833252 10C0.833252 15.1777 5.03058 19.375 10.2083 19.375Z"
        fill="white"
      />
      <path
        d="M15.5208 15.375H13.7708L12.5833 11.0625L10.0833 15.375H8.08325L11.9583 8.75L11.3333 6.4375L6.14575 15.375H4.02075L10.6458 4.0625H12.4583L13.2083 6.875H15.0208L13.8333 9L15.5208 15.375Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.208252)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default ALGO;
